<nav class="navbar navbar-expand-md navbar-light homehunt_nav" *ngIf="appState.companyInfo$ | async as companyInfo">
  <div class="text-center no_property_img">
    <img src="../../../../../assets/images/spend.jpg" width="150" alt="property" class="opacity-80" />
    <h6 class="mt-4 pl-1 pl-md-0">
      No properties were found
      <small class="btn-block mt-2"> {{ companyInfo?.geoCoverageConfig?.noCoverageMessage }} </small>
    </h6>
  </div>
</nav>
